import { render } from "./VotingCard.vue?vue&type=template&id=74c3bc39"
import script from "./VotingCard.vue?vue&type=script&lang=js"
export * from "./VotingCard.vue?vue&type=script&lang=js"

import "./VotingCard.vue?vue&type=style&index=0&id=74c3bc39&lang=css"
script.render = render

export default script